<template>
  <nav class="level app-levelbar">
    <div class="level-left">
      <div class="level-item">
        <h3 class="subtitle is-5">
          <strong>{{ name }}</strong>
        </h3>
      </div>
    </div>

    <div class="level-right is-hidden-mobile">
      <ol class="breadcrumb">
      <li v-for="(item,index) in list"><span class="active" v-if="isLast(index)">{{item.label}}</span>
        <router-link :to="{ name: item.link }" v-else>{{item.label}}</router-link>
      </li>
    </ol>
    </div>
  </nav>
</template>

<script>
export default {
  data () {
    return {
      defaultList: [
        {
          label: 'Home',
          link: 'dashboard'
        }
      ]
    }
  },
  computed: {
    menu(){
      return this.$store.state.menu
    },
    name () {
      return this.$route.meta.title || this.$route.name
    },

    list () {
      return this.defaultList.concat(this.find(this.name, this.menu))
    }
  },

  methods: {
    find (name, list) {
      let temp = []
      for (let i = 0, l = list.length; i < l; ++i) {
        let item = list[i]
        if (item.label === name || item.link === name) {
          temp.push({
            label: item.label,
            link: item.link
          })
          break
        }

        if (item.subMenu) {
          if (item.link) {
            temp.push({
              label: item.label,
              link: item.link
            })
          }
          let e = this.find(name, item.subMenu)
          if (e.length) {
            temp = temp.concat(e)
          } else if (item.link) {
            temp.pop()
          }
        }
      }

      return temp
    },
    isLast (index) {
      return index === this.list.length - 1
    }
  }
}
</script>

<style lang="less">
.breadcrumb {
  --separator: "\2044";

  list-style: none;
  align-items: center;
  display: flex;
  justify-content: flex-end;

  & > li + li:before {
    padding: 0 5px;
    color: #ccc;
    content: var(--separator, "\2044");
  }
}
</style>
